import React from "react";

import { SnackbarProvider } from "JS/Helpers/Snackbar";
import { useTheme, Theme, GlobalStyles } from "@mui/material";

export const AppSnackbarProvider = (props: { children: React.ReactNode }) => {
    const theme = useTheme<Theme>();

    return (
        <>
            <GlobalStyles
                styles={{
                    ".notistack-MuiContent-error": {
                        backgroundColor: `${theme.snackbar?.variantError} !important`,
                    },
                    ".notistack-MuiContent-success": {
                        backgroundColor: `${theme.snackbar?.variantSuccess} !important`,
                    },
                    ".notistack-MuiContent-info": {
                        backgroundColor: `${theme.snackbar?.variantInfo} !important`,
                    },
                    ".notistack-MuiContent-warning": {
                        backgroundColor: `${theme.snackbar?.variantWarning} !important`,
                    },
                }}
            />
            <SnackbarProvider
                maxSnack={4}
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "right",
                }}
                autoHideDuration={3000}
            >
                {props.children}
            </SnackbarProvider>
        </>
    );
};
